// Libs
import React from 'react'
// import { Router, browserHistory } from 'react-router-dom'
import { BrowserRouter as Router, } from 'react-router-dom'
// import { syncHistoryWithStore } from 'react-router-redux'

// Routes
import Routes from './routes'

// Store
import store from './store'

// Create an enhanced history that syncs navigation events with the store
// const history = syncHistoryWithStore(browserHistory, store)



const Root = () => (
  // <Router history={history}>{Routes}</Router>
  <Router>{Routes}</Router>
)

export default Root
